// Stałe współdzielone przez moduły formularza.

// Nazwa pola-pułapki. Musi być semantycznie pusta: pola nazwane „firma_www",
// „website", „url" itp. autofill przeglądarki i menedżery haseł wypełniają
// prawdziwym użytkownikom (incydent z zgubionym zgłoszeniem), a Chrome
// bywa głuchy na autocomplete="off". Zmiana wymaga synchronizacji z
// inc/brief/submit.php i docs/tools/check-brief.php.
export const HONEYPOT = "zgl_ref_b";

// Klucz szkicu w localStorage. Wersja w nazwie: zmiana zestawu pól
// unieważnia stare szkice zamiast odtwarzać śmieci.
export const DRAFT_KEY = "fs_brief_draft_v2";
export const DRAFT_MAX_AGE_DAYS = 30;
